import { onlyNumeric } from '@origin-digital/normalize';
import { connect } from 'react-redux';
import { Accordion, Text, Heading4 } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { Field, FieldArray, FieldArrayRenderProps } from 'formik';
import React from 'react';

import analytics from '../../../analytics';
import { updateCustomerDetail } from '../../../redux/actions/customer';
import { currencyTransform } from '../../../utils/transforms';
import FormRow from '../../../components/Form/Layout/FormRow';
import TextField from '../../../components/Form/Fields/TextField';
import RadioGroup from '../../../components/Form/Fields/RadioGroup';

import { StepTwoProps } from './StepTwo.types';
import Checkbox from '../../../components/Form/Fields/Checkbox';

import { stepTwo } from '../content.json';

export class StepTwo extends React.Component<StepTwoProps> {
  componentDidMount() {
    analytics.pageLoad('step2');
  }

  render(): JSX.Element {
    const { updateCustomerDetail, isInitialValid } = this.props;

    return (
      <React.Fragment>
        <FormRow content={stepTwo.content.yourDetails} byline={stepTwo.content.yourDetails.byline}>
          <Field
            name={stepTwo.fields.firstName.name}
            component={TextField}
            isInitialValid={isInitialValid}
            label={stepTwo.fields.firstName.label}
            maxLength={150}
            changeHandler={updateCustomerDetail}
          />
          <Field
            name={stepTwo.fields.lastName.name}
            component={TextField}
            isInitialValid={isInitialValid}
            label={stepTwo.fields.lastName.label}
            maxLength={150}
            changeHandler={updateCustomerDetail}
          />
          <Field
            name={stepTwo.fields.email.name}
            component={TextField}
            isInitialValid={isInitialValid}
            label={stepTwo.fields.email.label}
            maxLength={150}
            changeHandler={updateCustomerDetail}
          />
          <Field
            name={stepTwo.fields.phone.name}
            component={TextField}
            isInitialValid={isInitialValid}
            helpText={stepTwo.fields.phone.helpText}
            label={stepTwo.fields.phone.label}
            transform={onlyNumeric}
            maxLength={10}
            changeHandler={updateCustomerDetail}
          />
        </FormRow>

        <Box marginBottom={10}>
          <Accordion
            label={stepTwo.content.optionalAccordion.label}
            onToggle={e => {
              analytics.accordionClick(
                'speed-up',
                stepTwo.content.optionalAccordion.label,
                e.isOpen
              );
            }}
          >
            <Field
              name={stepTwo.fields.averageQuarterlyBillCost.name}
              component={TextField}
              isInitialValid={isInitialValid}
              label={stepTwo.fields.averageQuarterlyBillCost.label}
              transform={currencyTransform}
              changeHandler={updateCustomerDetail}
            />

            <FormRow content={stepTwo.content.usagePercentDuringDay}>
              <FieldArray
                name={stepTwo.fields.usagePercentDuringDay.name}
                render={(helpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={stepTwo.fields.usagePercentDuringDay.name}
                    options={stepTwo.fields.usagePercentDuringDay.options}
                    helpers={helpers}
                    maxWidth={300}
                    changeHandler={updateCustomerDetail}
                  />
                )}
              />
            </FormRow>

            <FormRow content={stepTwo.content.propertyStorey}>
              <FieldArray
                name={stepTwo.fields.propertyStorey.name}
                render={(helpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={stepTwo.fields.propertyStorey.name}
                    options={stepTwo.fields.propertyStorey.options}
                    helpers={helpers}
                    maxWidth={300}
                    changeHandler={updateCustomerDetail}
                  />
                )}
              />
            </FormRow>

            <FormRow content={stepTwo.content.roofPitch} byline={stepTwo.content.roofPitch.byline}>
              <FieldArray
                name={stepTwo.fields.roofPitch.name}
                render={(helpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={stepTwo.fields.roofPitch.name}
                    options={stepTwo.fields.roofPitch.options}
                    helpers={helpers}
                    maxWidth={300}
                    changeHandler={updateCustomerDetail}
                  />
                )}
              />
            </FormRow>

            <FormRow content={stepTwo.content.powerConnectionPhaseType}>
              <FieldArray
                name={stepTwo.fields.powerConnectionPhaseType.name}
                render={(helpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={stepTwo.fields.powerConnectionPhaseType.name}
                    options={stepTwo.fields.powerConnectionPhaseType.options}
                    helpers={helpers}
                    changeHandler={updateCustomerDetail}
                  />
                )}
              />
            </FormRow>
          </Accordion>
        </Box>
        <Box marginBottom={10}>
          <Heading4 text={'Stay informed'}></Heading4>
          <Box marginTop={2} marginBottom={4}>
            <Text size={'sm'}>{stepTwo.content.allowMarketingByline.text}</Text>
          </Box>
          <Field
            name={stepTwo.fields.allowMarketingCommunications.name}
            id={stepTwo.fields.allowMarketingCommunications.name}
            component={Checkbox}
            label={stepTwo.fields.allowMarketingCommunications.label}
            changeHandler={updateCustomerDetail}
          />
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  {
    updateCustomerDetail
  }
)(StepTwo);
